export default __webpack_public_path__ + "static/media/image-work-personal-w.b8cc0300.webp";